// =====================================
//
//   延遲公告 modal
//   Author: Gray
//   createtime: 2017 / 09 / 08
//   updatetime: 2017 / 09 / 21
//
// =====================================

window.InifECApp.directive('delayAnnouncement', ['$rootScope', '$ngModal', '$localStorage', 'OrderService', function ($rootScope, $ngModal, $localStorage, OrderService) {

	var _dir = {};

	var controller = ['$scope', function($scope) {

        // --------------------------------
        //  [private] 開啟 modal
        // --------------------------------
        var openModal = function() {

        	$ngModal.openModal('delay-announcement-modal');
        }

        // --------------------------------
        //  [private] 關閉 modal
        // --------------------------------
        var closeModal = function() {

        	$ngModal.closeModal('delay-announcement-modal');
        }

        // --------------------------------
        //  關閉
        // --------------------------------
        var cancel = function() {

            closeModal();
        }

        // --------------------------------
        //  切換是否今日再通知
        // --------------------------------
        var toggleNotify = function() {

            $scope.isNotify = !$scope.isNotify;
        }

        // --------------------------------
        //  [private] 更新localStorage
        // --------------------------------
        var updateNotifyLocalStorage = function() {

            if($scope.isNotify) {
                var now = new Date();
                var dd = now.getDate();
                var mm = now.getMonth() + 1;
                var yyyy = now.getFullYear();
                
                yyyy = yyyy.toString();
                mm = (mm < 10) ? '0' + mm.toString() : mm.toString();
                dd = (dd < 10) ? '0' + dd.toString() : dd.toString();

                var nowString = yyyy + mm + dd;

                $localStorage.delayAnnouncement = nowString;
            }
        }

        // --------------------------------
        //  [private] init
        // --------------------------------
        var init = function() {

            var now = new Date();
            var dd = now.getDate();
            var mm = now.getMonth() + 1;
            var yyyy = now.getFullYear();
            var day = now.getDay();

            yyyy = yyyy.toString();
            mm = (mm < 10) ? '0' + mm.toString() : mm.toString();
            dd = (dd < 10) ? '0' + dd.toString() : dd.toString();

            var nowString = yyyy + mm + dd;

            // 是否再提醒
            if($localStorage.delayAnnouncement === nowString) {
                return;
            }

            if(day == 0 || day == 6) {
                openModal();
                return;
            }

            OrderService.getOrderDelayAnnouncement().then(function(result) {

                if(result && result.delayDateMap) {

                    var announcement = result.delayDateMap[nowString];

                    if(announcement) {
                        openModal();
                        return;
                    }
                }
            });
        }

        /*==========================
            Events
        ==========================*/            
        $scope.$on('OPEN_DELAY_ANNOUNCEMENT_MODAL', function(event, data) {

            init();
        });

        $scope.$on('CLOSE_MODAL_COMPLETE', function(event, modalName) {

            if(modalName == 'delay-announcement-modal') {
                updateNotifyLocalStorage();
            }
        });

        /*==========================
            Members
        ==========================*/
        $scope.isNotify;

        $localStorage.$default({
            delayAnnouncement: undefined,
        });

        /*==========================
            Methods
        ==========================*/
        $scope.cancel = cancel; //  關閉
        $scope.toggleNotify = toggleNotify; // 切換是否今日再通知
        
        /*==========================
            init
        ==========================*/
        // init();
        
	}]

	_dir.restrict = "E";
	_dir.scope = true;
	_dir.templateUrl = "partials/modal/delay_announcement.html";
	_dir.controller = controller;

	return _dir;
}]);